const DocumentCheckMark = ({
  width,
  height,
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width || '24'}
      height={height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2002 18.4C17.2002 18.62 17.021 18.8 16.8002 18.8H12.2144C11.9847 19.2408 11.6936 19.6446 11.3525 20H16.8002C17.6834 20 18.4002 19.2832 18.4002 18.4V10.2624C18.4002 9.8384 18.2314 9.4312 17.9314 9.1312L13.2682 4.4688C13.2562 4.45684 13.2427 4.44646 13.2292 4.43616C13.2193 4.42854 13.2094 4.42096 13.2002 4.4128C13.1434 4.3616 13.0874 4.3112 13.025 4.2688C13.0048 4.25515 12.9826 4.24438 12.9606 4.23366C12.9478 4.22741 12.935 4.22117 12.9226 4.2144C12.9092 4.20688 12.8959 4.19917 12.8826 4.19146C12.8392 4.16638 12.7957 4.14118 12.7498 4.1216C12.5922 4.056 12.4226 4.0232 12.2506 4.0112C12.2348 4.01019 12.2192 4.00806 12.2036 4.00593C12.1819 4.00297 12.1601 4 12.1378 4H7.2002C6.317 4 5.6002 4.7168 5.6002 5.6V11.5985C5.97953 11.4403 6.38163 11.3258 6.8002 11.2612V5.6C6.8002 5.38 6.9794 5.2 7.2002 5.2H12.0002V8.8C12.0002 9.6832 12.717 10.4 13.6002 10.4H17.2002V18.4ZM13.2002 6.0968L16.3026 9.2H13.6002C13.3794 9.2 13.2002 9.02 13.2002 8.8V6.0968Z"
        fill="#A256BC"
      />
      <path
        d="M12.0002 16.4C12.0002 18.8301 10.0302 20.8 7.6002 20.8C5.17014 20.8 3.2002 18.8301 3.2002 16.4C3.2002 13.9699 5.17014 12 7.6002 12C10.0302 12 12.0002 13.9699 12.0002 16.4ZM10.283 14.5172C10.1268 14.3609 9.87356 14.3609 9.71735 14.5172L6.8002 17.4343L5.48304 16.1172C5.32683 15.9609 5.07356 15.9609 4.91735 16.1172C4.76114 16.2734 4.76114 16.5266 4.91735 16.6828L6.51735 18.2828C6.67356 18.4391 6.92683 18.4391 7.08304 18.2828L10.283 15.0828C10.4392 14.9266 10.4392 14.6734 10.283 14.5172Z"
        fill="#A256BC"
      />
    </svg>
  );
};
export default DocumentCheckMark;
